import Extender from './Extender';

export default Extender;
